import * as React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

import CartItemComponent from "../../../components/CartItemComponent";

const config = require("../../../constants/constants.js")
const { strCurrency, strEuroCurrency } = require('../../../utils/currencyUtils.js')

const EditOrderPageComponent = ({ getOrder, markAsDelivered }) => {

  const [validated, setValidated] = useState(false);
  const [order1, setOrder1] = useState([]);
  const [updateOrderResponseState, setUpdateOrderResponseState] = useState({ message: "", error: "" });

  const { id } = useParams();
  const navigate = useNavigate();

  const [userInfo, setUserInfo] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentDateTime, setPaymentDateTime] = useState("");
  const [paymentEmail, setPaymentEmail] = useState("");
  const [shippingAddress, setShippingAddress] = useState({});
  const [isPaid, setIsPaid] = useState(false);
  const [isDelivered, setIsDelivered] = useState(false);
  const [cartSubtotal, setCartSubtotal] = useState(0);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [orderButtonMessage, setOrderButtonMessage] = useState("Imposta come consegnato");
  const [cartItems, setCartItems] = useState([]);

  const [shipping, setShipping] = useState("inclusa");
  const [tax, setTax] = useState("inclusa");

  const [showAlertSpedito, setShowAlertSpedito] = useState(false);
  const [showAlertPagato, setShowAlertPagato] = useState(false);

  useEffect(() => {
    getOrder(id)
      .then((order) => {
        setUserInfo(order?.user);
        setPaymentMethod(order?.paymentMethod);
        setPaymentDateTime(order?.transactionResult.createTime);
        setIsPaid(order?.isPaid);
        setPaymentEmail(order?.transactionResult.email);
        setShippingAddress(order?.shippingAddress[0]);
        order.isDelivered
          ? setIsDelivered(order.deliveredAt)
          : setIsDelivered(false);
        setCartSubtotal(order.orderTotal.cartSubtotal);
        if (order.isDelivered) {
          setOrderButtonMessage("Ordine concluso");
          setButtonDisabled(true);
        }
        setCartItems(order.cartItems);
        console.log(`order =`, order);
        console.log(`order.user =`, order.user);
        console.log(`order.shippingAddress =`, order.shippingAddress);

      })
      .catch((er) =>
        console.log("")
        //dispatch(logout())
        // console.log(
        //   er.response.data.message ? er.response.data.message : er.response.data
        // )
      );
  }, [isDelivered, id]);

  function salvaOrderModificato(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    /*
    console.log(`title dig =`, title);
    console.log(`name dig =`, name);
    console.log(`surname dig =`, surname);
    console.log(`telephone dig =`, telephone);
    console.log(`mobile dig =`, mobile);
    console.log(`email dig =`, email);
    console.log(`via dig =`, via);
    console.log(`cap dig =`, cap);
    console.log(`citta dig =`, citta);
    console.log(`provincia dig =`, provincia);
    console.log(`piva dig =`, piva);
    console.log(`codicefiscale dig =`, codicefiscale);

    updateOrderApiRequest(id, title, name, surname, telephone, mobile, email, via, cap, citta, provincia, piva, codicefiscale, image)
      .then(data => {
        if (data.success === "order updated") {
          navigate("/admin/orders");
        }
      })
      .catch(er => {
        setUpdateOrderResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data });
      })
    */

    window.location.assign('/admin/orders')
  }

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();
    window.location.assign('/admin/orders')
  }

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/orders">
              {config.BC_ADMIN_ORDERS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_ORDERS_VIEW}</Typography>
          </Breadcrumbs>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 30
            }}
          />

          <Grid container spacing={4}>

            <Grid
              size={{ xs: 12, md: 4 }}
              paddingTop={{ xs: 0, md: 0 }}
              paddingLeft={{ xs: 0, md: 2 }}
            >

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6',
                  background: '#bfdae3ff',
                }}
                elevation={6}
              >

                <Typography variant="h5" color='#1136a0'
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    p: 1, m: 0,
                  }}
                >
                  Spedizione
                </Typography>


                <Grid container
                  spacing={2}
                  sx={{
                    paddingTop: 1, paddingLeft: 2, paddingRight: 2,
                  }}
                >

                  <Grid size={12}>

                    <Stack spacing={2}
                      sx={{
                        flexDirection: { xs: "column", md: "column" },
                      }}
                    >

                      <TextField id="id-nome" label="Cognome e nome" variant="outlined"
                        value={shippingAddress.nameSurname}
                        size="small"
                        slotProps={{
                          inputLabel: { shrink: true },
                          input: { readOnly: true },
                        }}
                        onChange={(event) => {
                          //setNameSurname(event.target.value);
                        }}
                      />

                      <TextField id="id-indirizzo" label="Indirizzo" variant="outlined"
                        value={shippingAddress.address + ", " + shippingAddress.zip + " " + shippingAddress.city}
                        size="small"
                        slotProps={{
                          inputLabel: { shrink: true },
                          input: { readOnly: true },
                        }}
                        onChange={(event) => {
                          //setAddress(event.target.value);
                        }}
                      />
                    </Stack>

                  </Grid>


                  <Grid container spacing={2}
                    sx={{
                      paddingTop: 0,
                    }}
                  >

                    <Grid size={6}>

                      <TextField id="id-telefono" label="Telefono" variant="outlined"
                        value={shippingAddress.phone}
                        size="small"
                        slotProps={{
                          inputLabel: { shrink: true },
                          input: { readOnly: true },
                        }}
                        onChange={(event) => {
                          //setAddress(event.target.value);
                        }}
                      />

                    </Grid>

                    <Grid size={6}>

                      <TextField id="id-telefono" label="Spedito" variant="outlined"
                        value={
                          isDelivered ? (<>Spedito il {isDelivered.substring(8, 10) + '/' + isDelivered.substring(5, 7) + '/' + isDelivered.substring(0, 4)}</>
                          ) : (
                            <>Non spedito</>
                          )
                        }
                        size="small"
                        slotProps={{
                          inputLabel: { shrink: true },
                          input: { readOnly: true },
                        }}
                        onChange={(event) => {
                          //setAddress(event.target.value);
                        }}
                      />
                    </Grid>

                  </Grid>

                </Grid>
              </Paper>

            </Grid>

            <Grid
              size={{ xs: 12, md: 4 }}
              paddingTop={{ xs: 0, md: 0 }}
              paddingLeft={{ xs: 0, md: 0 }}
            >

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6',
                  background: '#bfdae3ff',
                }}
                elevation={6}
              >

                <Typography variant="h5" color='#1136a0'
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    p: 1, m: 0,
                  }}
                >
                  Data e pagamento
                </Typography>

                <Grid container
                  spacing={2}
                  sx={{
                    paddingTop: 1, paddingLeft: 2, paddingRight: 2,
                  }}
                >

                  <Grid container spacing={2}
                    sx={{
                      paddingTop: 1,
                    }}
                  >

                    <Grid size={6}>

                      <TextField id="id-method" label="Metodo pagamento" variant="outlined" value={paymentMethod === "cc" ? "carta di credito" : ""}
                        size="small"
                        slotProps={{
                          input: { readOnly: true },
                          inputLabel: { shrink: true },
                        }}
                        onChange={(event) => {
                          //setName(event.target.value);
                        }}
                      />

                    </Grid>

                    <Grid size={6}>

                      <TextField id="id-price" label="Pagato il" variant="outlined" value={paymentDateTime}
                        size="small"
                        slotProps={{
                          input: { readOnly: true },
                          inputLabel: { shrink: true },
                        }}
                        onChange={(event) => {
                          //setName(event.target.value);
                        }}
                      />
                    </Grid>

                  </Grid>

                  <Grid container spacing={2}
                    sx={{
                      paddingTop: 0,
                    }}
                  >

                  <Grid size={12}>

                    <TextField id="id-emailnotify" label="Email notifica" variant="outlined" value={paymentEmail}
                      size="small"
                      slotProps={{
                        input: { readOnly: true },
                        inputLabel: { shrink: true },
                      }}
                      onChange={(event) => {
                        //setName(event.target.value);
                      }}
                    />
                  </Grid>

                </Grid>
                </Grid>

              </Paper>

            </Grid>

            <Grid
              size={{ xs: 12, md: 3 }}
              paddingTop={{ xs: 0, md: 0 }}
              paddingLeft={{ xs: 0, md: 0 }}
            >

              <Paper
                sx={{
                  paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
                  background: '#cce0e6',
                  background: '#bfdae3ff',
                }}
                elevation={6}
              >

                <Typography variant="h5" color='#1136a0'
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    p: 1, m: 0,
                  }}
                >
                  Importo
                </Typography>


                <Box
                  // colonna centrale Prezzi
                  sx={{ '& > :not(style)': { m: 1, width: '19ch' } }}
                  noValidate
                  autoComplete="off"
                >

                  <TextField id="id-price" label="Prezzo articoli" variant="outlined" value={strEuroCurrency(cartSubtotal)}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                  <TextField id="id-shipping" label="costo spedizione" variant="outlined" value={shipping}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                  <TextField id="id-tax" label="iva" variant="outlined" value={tax}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                  <TextField id="id-totalPrice" label="Prezzo totale" variant="outlined" value={strEuroCurrency(cartSubtotal)}
                    size="small"
                    slotProps={{
                      input: { readOnly: true },
                      inputLabel: { shrink: true },
                    }}
                    onChange={(event) => {
                      //setName(event.target.value);
                    }}
                  />

                </Box>

              </Paper>

            </Grid>

          </Grid>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

          <Grid
            size={{ xs: 12, md: 10 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 2 }}
          >
            <Paper
              sx={{
                paddingTop: 0, paddingBottom: 2, paddingLeft: 0, paddingRight: 0,
                background: '#cce0e6',
                background: '#bfdae3ff',
              }}
              elevation={6}
            >

              <Typography variant="h5" color='#1136a0'
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  p: 1, m: 0,
                }}
              >
                Articoli ordinati
              </Typography>

              <List variant="flush">
                {cartItems.map((item, idx) => (
                  <CartItemComponent key={idx} item={item} orderCreated={true} />
                ))}
              </List>

            </Paper>

          </Grid>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid >

    </Box >

  );
};

export default EditOrderPageComponent;
